export interface PrequalificationReportUUID {
  uuid: string;
}
